export const siteDescription = {
  Palm: {
    title: 'About Us',
    text: 'PALM Expo Magazine is India’s only bi-monthly professional audiovisual magazine. Covering stage sound, lighting, install sound, music production, and DJ gear, it delivers trusted news, product updates, interviews, and industry insights.',
  },
  AvIcnExpo: {
    title: 'Opening hours',
    text: '28 May 2026: 10:00 AM - 6:00\nPM 29 May 2026: 10:00 AM - 6:00\nPM 30 May 2026: 10:00 AM - 5:00 PM',
  },
};
export const siteLinks = {
  Palm: {
    title: 'Explore',
    items: [
      {
        title: 'News & Insights',
        href: '/news-insights',
        target: '_blank',
      },
      {
        title: 'Articles',
        href: '/articles',
        target: '_blank',
      },
      {
        title: 'Magazine Archives',
        href: '/magazine-archive',
        target: '_blank',
      },
      {
        title: 'Contact Us',
        href: '/contact-us',
        target: '_blank',
      },
    ],
  },
  AvIcnExpo: {
    title: 'Explore',
    items: [
      {
        title: 'AV-ICN Expo Magazine',
        href: '/magazine',
        target: '_blank',
      },
      {
        title: 'Why visit',
        href: '/why-visit',
        target: '_blank',
      },
      {
        title: 'Sponsorship opportunities',
        href: '/sponsorship-opportunities',
        target: '_blank',
      },
      {
        title: 'Contact us',
        href: '/contact-us',
        target: '_blank',
      },
    ],
  },
};

export const generalLinks = [
  {
    title: 'informa.accessibility',
    href: 'https://www.informamarkets.com/en/accessibility.html',
    target: '_blank',
  },
  {
    title: 'event.privacy-centre',
    href: 'https://privacy.informa.com/',
    target: '_blank',
  },
  {
    title: 'event.terms-of-use',
    href: 'https://www.informamarkets.com/en/terms-of-use.html',
    target: '_blank',
  },
  {
    title: 'event.terms-and-conditions',
    href: 'https://www.informamarkets.com/en/visitor-terms-and-conditions.html',
    target: '_blank',
  },
  {
    title: 'event.code-of-conduct',
    href: 'https://www.informamarkets.com/en/event-code-of-conduct.html',
    target: '_blank',
  },
];
